import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface AuthGuardProps {
  checkFunction: () => boolean | Promise<boolean>;
  redirectTo: string;
  redirectToFail: string;
  children: React.ReactNode;
}

export function AuthGuard({
  checkFunction,
  redirectTo,
  redirectToFail,
  children,
}: AuthGuardProps) {
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const isValid = await checkFunction();
        setIsAuthorized(isValid);

        // Редиректим только если проверка не пройдена
        if (!isValid) {
          navigate(redirectToFail, { replace: true });
        }
      } catch (error) {
        console.error('Auth check failed:', error);
        setIsAuthorized(false);
        navigate(redirectToFail, { replace: true });
      } finally {
        setIsChecking(false);
      }
    };

    checkAuth();
  }, [checkFunction, redirectToFail, navigate]);

  if (isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-lg">Проверка авторизации...</div>
      </div>
    );
  }

  return isAuthorized ? children : null;
}

export const checkToken = async (): Promise<boolean> => {
  return new Promise((resolve) => {
    const token = localStorage.getItem('token');
    resolve(!!token && token.trim() !== '');
  });
};
